import React from 'react';
import './ParentPackageCard.css';
import testImage from '../../../../assets/images/packages/test.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../contexts/TranslationContext';


const ParentPackageCard = ({ pageData, url }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const goToPackages = () => {

    
    navigate(`/packages/${pageData.name}`);
  };



 
  
    const image = pageData?.image
      ? `${url}${encodeURI(pageData.image)}`
      : testImage;
  
    return (
      
      <>
      {
        // pageData?.total_packages !== 0 ? (
          <div className="ParentPackageCard-card-container" data-aos="zoom-in" data-aos-duration="1500"
          onClick={goToPackages}
          >
            <div
              className="ParentPackageCard-card-content"
              style={{ backgroundImage: `url(${image})` }}
            >
              <div className="ParentPackageCard-overlay" />
              <div className="ParentPackageCard-card-content-text">
                <div className="ParentPackageCard-card-content-text-count">
                   {pageData?.total_packages} {t("PackagesIncluded")}
                </div>
                <div className="ParentPackageCard-card-content-text-name">
                  {pageData.category_name || 'Unnamed Package'}
                </div>
              </div>
            </div>
          </div>
        // ) : (
        //   <div className='d-none'></div>
        // )
      }
      </>
     
    );
  
  
};

export default ParentPackageCard;
